var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.exists || _vm.auth
    ? _c(
        "div",
        { staticClass: "u-col", attrs: { id: "app" } },
        [
          _c("layout-header"),
          _vm._v(" "),
          _c("router-view", { staticClass: "l-section u-flex" }),
          _vm._v(" "),
          _c("layout-footer"),
          _vm._v(" "),
          _c("layout-popup"),
          _vm._v(" "),
          _c("layout-toasts")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }